import { useCallback } from "react";
import { useTranslation } from "react-i18next";

export const PAGE_NAMES = {
  home: "Homepage",
  startDownload: "Start Download Page",
  appDownloading: "Hyper App is Downloading Page",
  signup: "Signup Page",
  signupSuccessful: "Sign up successful Page",
  loginSuccessful: "Log In Successful Page",
  selectCountry: "Select country Page",
  selectReward: "Select reward Page",
  suggestions: "Suggestions Page",
  referralCode: "Referral code Page",
  createUsername: "Create username Page",
  congratulatoryReward: "Congratulatory Reward Page",
  welcomeBack: "Welcome Back",
};

export function usePlayGameMetaDescription() {
  const { t } = useTranslation("metadata");
  const generatePlayGameDescription = useCallback(
    (gameName?: string, genreName = "") =>
      t("play_game_description", {
        dynamicText:
          gameName ?? t("the_best_genre_games_on_the_appstore", { genreName }),
      }),
    [t]
  );

  return {
    generic: t("one_app_with_100s_of_the_best_games_from_the_app_stores"),
    playGames: generatePlayGameDescription(),
    generatePlayGameDescription,
  };
}
